// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';

function handleNameChange(event) {

    this('name', event.target.value);

}

const AgencyName = ({onItemChange, statusChangeRequest}) => {

    const status = statusChangeRequest.newStatus.key;

    return (
        <div className='labeled-string'>
            <span className='data-label'>
                <sup>{status === 'STL1' || status === 'STLP' ? '*' : null}</sup> <FormattedMessage id='AGENCY_NAME'/>
            </span>
            <input
                maxLength='29'
                onChange={onItemChange::handleNameChange}
                type='text'
            />
        </div>
    );

};

AgencyName.displayName = 'AgencyName';
AgencyName.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default AgencyName;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/agency-name.js